module.exports = __webpack_public_path__ + "static/media/ding.03210e2d.mp3";